module.exports = __webpack_public_path__ + "img/salesflow@2x.9afa88bb.png";